<template>
  <el-collapse :value="['1']" >
    <MyCollapse iconPath="/static/de-zmr.png" title="救助申请审核记录" name="1">
      <el-table
        :data="tableData"
        v-loading="loading"
        style="width: 100%"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.5)"
      >
        <el-table-column prop="apprNodeText" width="150" label="节点名称">
        </el-table-column>
        <el-table-column prop="apprStatusText" width="120" label="流程状态">
          <template v-slot="scope">
            {{ scope.row.apprStatus == 1 ? '提交' :  scope.row.apprStatusText}}
          </template>
        </el-table-column>
        <el-table-column prop="apprUserText" width="250" label="经办人">
        </el-table-column>
        <el-table-column prop="apprTime" width="140" label="处理时间">
          <template v-slot="scope">
            {{ parseTime(scope.row.apprTime, '{y}-{m}-{d} {h}:{i}') }}
          </template>
        </el-table-column>
        <el-table-column prop="apprOpinion" label="意见说明" align="left">
        </el-table-column>
      </el-table>
    </MyCollapse>
  </el-collapse>
</template>

<script>
import { getJzshDataListByCondNoPaging } from "@/util/api";
import Pageination from '@/components/business/Pageination'
import dialogPanel from "@/components/business/dialogPanel";
import MyCollapse from '@/components/business/MyCollapse'

export default {
  components: {
    Pageination,
    MyCollapse,
    dialogPanel,
  },
  props: {
    helpReqId: String,
    helpId: String,
  },
  data() {
    return {
      loading: false,
      tableData: [],
    };
  },
  mounted () {
    this.queryList();
  },
  methods: {
    queryList () {
      // if (this.helpId) {
        this.loading = true;
        getJzshDataListByCondNoPaging({
          searchCond: {
            helpReqId: this.helpReqId,
            helpId: this.helpId
          },
           "orderBy":"apprTime desc",
        }).then((res) => {
          this.tableData = res.responseData.modelData;
          this.loading = false;
        });
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/common/common.scss";
</style>



// WEBPACK FOOTER //
// src/pages/child/hospital/HospitalChildHistory.vue